import { Autocomplete, Box, Button, FormControl, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import { workflowService } from '../../../services/admin/workflow'
import { FIELD_TYPES } from '../../../utility/constants'

const PreventProcessCreationUI = ({ fieldTemplate, processTemplateId, activityTemplateId }) => {
  const { user } = useAuthContext()
  const [activities, setActivities] = useState([])
  const [allFields, setAllFields] = useState([])
  const [activity, setActivity] = useState(null)
  const [constraintFields, setConstraintFields] = useState([])

  useEffect(() => {
    if (user) {
      ;(async () => {
        const list = await workflowService.getActivities(user, processTemplateId)

        const allFields = (
          await fieldTemplateService.getAllFieldsInActivity(user, activityTemplateId)
        ).data.filter((it) => it.is_subfield == false && it.data_structure != FIELD_TYPES.TABLE)

        setActivities(list)
        setAllFields(allFields)

        // fetch prevent process data for pivot field
        const preventData = await fieldTemplateService.getPreventProcessCreationConfig(
          user,
          fieldTemplate.id
        )

        if (preventData?.length > 0 && list?.length > 0) {
          setActivity(list.find((it) => it.id == preventData[0]?.must_exist_activity_template_id))

          const constraintFieldTemplateIds = preventData[0]?.constraint_field_template_ids || []
          if (allFields.length > 0 && constraintFieldTemplateIds.length > 0) {
            setConstraintFields(
              allFields.filter((field) => constraintFieldTemplateIds.includes(field.id))
            )
          }
        }
      })()
    }
  }, [processTemplateId, user])

  const saveConstraints = async () => {
    try {
      const constraintFieldIds = constraintFields.map((it) => it.id)

      const data = {
        source_process_template_id: processTemplateId,
        pivot_field_template_id: fieldTemplate.id,
        must_exist_activity_template_id: activity?.id,
        constraint_field_template_ids: constraintFieldIds,
      }

      await fieldTemplateService.setPreventProcessCreationConfig(user, fieldTemplate.id, data)
      toast.success('Added prevent process config!')
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  return (
    <Box>
      <Typography variant="p">Prevent Process Creation</Typography>
      <Typography variant="body2" fontSize="10px">
        This configuration prevents process creation until the previous instance with the same pivot
        field value reaches a specific checkpoint (particular activity).
      </Typography>
      <FormControl variant="outlined" fullWidth size="small" color="primary">
        <Autocomplete
          style={{ marginTop: 16 }}
          id="list-item-selection"
          fullWidth
          value={activity || null}
          options={activities}
          getOptionLabel={(it) => it.activity_template_name}
          renderInput={(params) => (
            <TextField {...params} label="Select Checkpoint Activity" color="primary" />
          )}
          onChange={(e, v) => setActivity(v)}
          size="small"
        />

        <Autocomplete
          style={{ marginTop: 16 }}
          id="constraint-field-selection"
          fullWidth
          value={constraintFields || []}
          options={allFields}
          multiple
          getOptionLabel={(it) => it.field_template_name}
          renderInput={(params) => (
            <TextField {...params} label="Constraint fields (optional)" color="primary" />
          )}
          onChange={(e, v) => setConstraintFields(v)}
          size="small"
        />
        <Typography variant="body2" fontSize="10px">
          When Constraint fields (optional) are included, the comparison will also consider these
          field values from the previous instance.
        </Typography>
      </FormControl>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, gap: 16 }}>
        <Button color="primary" variant="contained" onClick={saveConstraints}>
          Save
        </Button>
      </div>
    </Box>
  )
}

export default PreventProcessCreationUI
